import React, { useState, useEffect } from "react";

export function SettingsPanel({ currentFolder, visibility = true, onChangeVisibility }) {
  const [isVisible, setIsVisible] = useState(visibility);

  useEffect(() => {
    setIsVisible(visibility);
  }, [visibility]);

  const toggleVisibility = () => {
    const next = !isVisible;
    setIsVisible(next);
    onChangeVisibility?.(next);
  };

  return (
    <div style={{ padding: "1rem" }}>
      <h3>Folder Settings</h3>

      <div style={{ marginBottom: "1rem" }}>
        <strong>Folder:</strong> {currentFolder}
      </div>

      <div
        style={{
          padding: "10px",
          border: "1px solid #ccc",
          borderRadius: "6px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between"
        }}
      >
        <span>Visible:</span>
        <button
          onClick={toggleVisibility}
          style={{
            padding: "6px 10px",
            background: isVisible ? "#4CAF50" : "#aaa",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer"
          }}
        >
          {isVisible ? "ON" : "OFF"}
        </button>
      </div>
    </div>
  );
}
